// extracted by mini-css-extract-plugin
module.exports = {"BobPage":"BobPage_BobPage__2hpKj"};